/**
 * Constantes centralizadas de gamificação.
 */

/** Ícones disponíveis para conquistas (Material Design Icons) */
export const ACHIEVEMENT_ICONS = [
    "mdi-trophy",
    "mdi-star",
    "mdi-medal",
    "mdi-crown",
    "mdi-shield-star",
    "mdi-heart",
    "mdi-fire",
    "mdi-diamond-stone",
    "mdi-star-circle",
    "mdi-fish",
    "mdi-water",
    "mdi-waves"
];
